/** Orden de temporada dentro del año (calendario moda). */
const SEASON_RANK = {
  PS: 1,
  SS: 2,
  PF: 3,
  SP: 4,
  FA: 5,
  AW: 6,
  FW: 6,
  RE: 7,
};

function normalizeSeasonCode(raw) {
  return String(raw || "")
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "");
}

function seasonCodeRank(codeOrName) {
  const n = normalizeSeasonCode(codeOrName);
  const letters = n.replace(/\d+/g, "");
  return SEASON_RANK[letters] || 50;
}

function parseYearFromSeasonName(name) {
  const n = String(name || "").trim();
  const m = n.match(/(20\d{2}|\d{2})\s*$/);
  if (!m) return null;
  let y = Number(m[1]);
  if (!Number.isFinite(y)) return null;
  if (y < 100) y += 2000;
  return y;
}

/**
 * Clave numérica para ordenar temporadas: año desc, estación asc.
 * Menor = más arriba en el grid.
 */
export function getSeasonSortKey(seasonName, temporadas = []) {
  const name = String(seasonName || "").trim();
  if (!name || name === "N/A") return Number.POSITIVE_INFINITY;

  const upper = name.toUpperCase();
  const catalog = (temporadas || []).find((t) => {
    const temp = String(t.TEMPORADA || t.Temporada || "").trim().toUpperCase();
    const abr = String(t.ABREVIATURA || "").trim().toUpperCase();
    return temp === upper || abr === upper || abr.replace(/\s+/g, "") === upper;
  });

  const year =
    Number(catalog?.YEAR) ||
    parseYearFromSeasonName(catalog?.TEMPORADA || catalog?.Temporada || name) ||
    0;
  const rank = seasonCodeRank(
    catalog?.ABREVIATURA || catalog?.TEMPORADA || catalog?.Temporada || name,
  );

  // Año más reciente primero; dentro del año PS→SS→…→AW
  return (10_000 - year) * 100 + rank;
}

export function compareSeasonNames(a, b, temporadas = []) {
  const ka = getSeasonSortKey(a, temporadas);
  const kb = getSeasonSortKey(b, temporadas);
  if (ka !== kb) return ka - kb;
  return String(a || "").localeCompare(String(b || ""), "es", {
    sensitivity: "base",
  });
}

/** Orden del árbol Estimates: Temporada → Cliente → Proyecto → Diseño
 *  o Cliente → Temporada → Proyecto → Diseño según `mode`.
 */
export function compareEstimateTreeRows(
  a,
  b,
  temporadas = [],
  mode = "client",
) {
  const clientA = String(a?.ClienteNombre || a?.MarcaNombre || "");
  const clientB = String(b?.ClienteNombre || b?.MarcaNombre || "");
  const clientCmp = clientA.localeCompare(clientB, "es", {
    sensitivity: "base",
  });

  const seasonCmp = compareSeasonNames(
    a?.TemporadaNombre,
    b?.TemporadaNombre,
    temporadas,
  );

  if (mode === "client") {
    if (clientCmp !== 0) return clientCmp;
    if (seasonCmp !== 0) return seasonCmp;
  } else {
    if (seasonCmp !== 0) return seasonCmp;
    if (clientCmp !== 0) return clientCmp;
  }

  const projectCmp = String(a?.ProyectoNombre || "").localeCompare(
    String(b?.ProyectoNombre || ""),
    "es",
    { sensitivity: "base" },
  );
  if (projectCmp !== 0) return projectCmp;

  return String(a?.DiseñoMuestra || "").localeCompare(
    String(b?.DiseñoMuestra || ""),
    "es",
    { sensitivity: "base" },
  );
}

export function getEstimateTreeDataPath(row, mode = "client") {
  const season = row?.TemporadaNombre || "N/A";
  const client = row?.ClienteNombre || row?.MarcaNombre || "N/A";
  const project = row?.ProyectoNombre || "N/A";
  const sample = `${row?.DiseñoMuestra || "N/A"} — ${row?.IdPresupuesto}`;

  if (mode === "season") {
    return [season, client, project, sample];
  }
  return [client, season, project, sample];
}

export function getEstimateTreeGroupHeader(mode = "client") {
  return mode === "season"
    ? "Season / Client-Brand / Project / Sample | Design"
    : "Client-Brand / Season / Project / Sample | Design";
}
